<template>
	<div class="w-100 border-semi-grey radius-12 p-3 d-block cursor-pointer" @click="goToDetail()">
		<div class="d-inline-block align-middle" style="height:48px;width:48px;">
			<img :src="data.image_url" class="img-fit radius-6" />
		</div>
		<div class="d-inline-block align-middle pl-2 w-75">
			<p class="mb-1 body-1-2 text-truncate">{{data.name}}</p>
			<p class="mb-0 body-2-2-1 text-truncate">{{return_data.description}}</p>
		</div>
	</div>
</template>
<script>
	export default{
		props: ['type','data'],
		computed:{
			return_data(){
				if(this.type == 'social_media'){
					return{
						url: this.data.account_url,
						description: this.data.account_id
					}
				}else{
					return this.data
				}
			}
		},
		methods:{
			goToDetail(){
				let section = this.type == 'social_media' ? 'SOCIAL MEDIA' : 'CUSTOM URL'
				this.$postLog('HOME',section,`Clicked  ${this.data.name}`)
      	setTimeout(()=>{
      		let tag_a = document.createElement('a')
      		tag_a.href = this.return_data.url
      		tag_a.target = '_blank'
      		tag_a.click()
      		tag_a.remove()
      	},300)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/CustomUrl.vue